import React from 'react'
import {Line} from 'react-chartjs-2';
import axios from 'axios';
import numeral from "numeral";

const options = {
    legend:{
        display:false
    },
    elements:{
        point:{
            radius:0,
        },
    },
    maintainAspectRatio:false,
    tooltips:{
        mode:"index",
        intersect:false,
        callbacks:{
            label:function(tooltipItem,data) {
                return numeral(tooltipItem.value).format("+0,0")
            },
        },
    },
    scales:{
        xAxes:[
            {
                type:"time",
                time:{
                    format:"MM/DD/YYYY",
                    tooltipFormat:"ll"
                },
            },
        ],
        yAxes:[
            {
                gridLines:{
                    display:false
                },
                ticks:{
                    callback:function (value,index,values) {
                        return numeral(value).format("0a")
                    },
                },
            },
        ]
    }

}

function LineGraph({casesType}) {
    const [data,setData]= React.useState()
    // 
    React.useEffect(() => {
        axios.get('https://disease.sh/v3/covid-19/historical/all?lastdays=100')
        .then(res => {
            
            
            let chartData = buildChartData(res.data)
            
            setData(chartData)
        })
        .catch(err => {
            console.log(err)
        });
    },[casesType])

    const buildChartData = (data) => {
        let chartData = [];
        let lastDataPoint;
        
        for(let date in data[casesType]){
            
            if(lastDataPoint) {
                const newDataPoint = {
                    x:date,
                    y:data[casesType][date] - lastDataPoint
                }
                chartData.push(newDataPoint)
            }
            lastDataPoint = data[casesType][date]
        }
        return chartData
    }
    
    return (
        <div>
            {data ?
                <Line
                options={options}
                    data = {{
                        datasets:[
                            {
                                backgroundColor:"red",
                                borderColor:"#cc1034",
                                data:data,
                            }
                        ]
                    }}
                /> :null
             }
            
        </div>
    )
}

export default LineGraph
